import React from "react";
import {
    Nav,
    NavItem,
    NavLink
} from 'reactstrap'

/**
 * Component -> Pill Navigation component
 * @param navList Navigation list array
 * @param active Navigation list component active state
 * @param toggle Navigation list component toggle state function
 * @returns
 */

const PillNavigation = ({ navList, active, toggle }) => {
    return (
        <Nav pills>
            {navList.map((item, index) => {
                return <NavItem key={item.id}>
                    <NavLink
                        active={active === item.id}
                        onClick={() => {
                            toggle(item.id)
                        }}
                    >
                        {item.item}
                    </NavLink>
                </NavItem>
            })}
        </Nav>
    )
}

export default PillNavigation
